
<div class="header-inner">
    <div class="header-identity">
        <a [routerLink]="['/']"  class="logo" title="Navigate to Huron Consulting Group Home">
            <img src="assets/huron-white.svg" alt="Huron Consulting Group Logo">
        </a>
        <a *ngIf="!isCurrPageAdminApp()" class="app-name" [routerLink]="['/']" title="Navigate to {{configService.appSettings.applicationName}} Home">{{ configService.appSettings.applicationName }}</a>
        <a *ngIf="isCurrPageAdminApp()" class="app-name" [routerLink]="['/admin']" title="Navigate to Administrative Tools Home">Administrative Tools</a>
    </div>
    <nav *ngIf="showMenuButton" class="main-nav" [ngClass]="{'active':showMenu}">
        <button class="menu" (click)="toggleMenu()">Menu</button>
        <div hhsg-header-menu *ngIf="showMenu"
            [headerLinks]="headerLinks"
            [sectionLinks]="sectionLinks"
            [applicationLinks]="applicationLinks"
            [isMobile]="isMobile"
            (closeMenu)="toggleMenu()">
        </div>
    </nav>
    <nav class="user-nav" role="menu">
        <span *ngIf="user?.brandingName" class="user-location">{{user?.brandingName}}</span>
        <span *ngIf="user?.brandingName" class="pipe">|</span>
        <a class="user-name" [routerLink]="['/profile']">
            <span class="name">{{user?.firstName}} {{user?.lastName}}</span>
        </a>
        <div class="notifications unread">
            <a class="notification-link">
                <span class="icon-bell"></span>
            </a>
        </div>
        <a class="logout" [routerLink]="['/logout']">Log out</a>
    </nav>
</div>
